import React from "react"
import { useSelector } from 'react-redux'

// Load custom components
import BackdropHero from "./BackdropHero"
import ColumnHero from "./ColumnHero"

const Hero = () => {
    const isAuthed = useSelector((state) => state.user.isAuthed)
    
    // Look up the color palette
    const themeLookUp = process.env.REACT_APP_PARTNER ? process.env.REACT_APP_PARTNER : 'leidsa'
    
    // Show the Leidsa hero only
    if (themeLookUp === 'leidsa') {
        return <ColumnHero isAuthed={isAuthed} />
    }
    
    return <BackdropHero isAuthed={isAuthed} />
}

export default Hero